import { render, staticRenderFns } from "./AvailableFormatsSelection.vue?vue&type=template&id=43f2005e&scoped=true&"
import script from "./AvailableFormatsSelection.vue?vue&type=script&lang=js&"
export * from "./AvailableFormatsSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f2005e",
  null
  
)

export default component.exports